import template from '../templates/directives/notes.html';

const directive = [
];

const fn = (
) => {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: template,
        link(scope, element) {
            element[0].classList.add('footer');
        },
    };
};

directive.push(fn);

export default directive;



// WEBPACK FOOTER //
// ./resources/assets/app-releases/directives/notes.js